import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { filter, firstValueFrom } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';

export const guestGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  await firstValueFrom(toObservable(authService.isInitialized).pipe(filter(i => i)));

  if (authService.isLoggedIn() && authService.userProfile()) {
    return router.parseUrl('/aguai-2026/registration');
  }

  return true;
};
